(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').controller('myPlanController', MyPlanController);

  MyPlanController.$inject = ['$rootScope',
    '$window',
    'uteModal',
    'permissionsService',
    'commonService',
    'env',
    'wirelessDashboardService',
    'manageDataService',
    '$timeout',
    'uteLocale'];

  function MyPlanController($rootScope,
                            $window,
                            uteModal,
                            permissionsService,
                            commonService,
                            env,
                            wirelessDashboardService,
                            manageDataService,
                            $timeout,
                            uteLocale) {
    var mpCtrl = this;
    var cacheExpiredForPP = false;
    init();

    function init() {
      mpCtrl.language = uteLocale.language;
      mpCtrl.close = true;
      mpCtrl.isOpenCTNDetals = false;
      mpCtrl.pricePlanInfoError = false;
      mpCtrl.dataByteEligible = false;
      mpCtrl.learnMoreLink = (mpCtrl.language === 'en') ? env.enFidoRoam : env.frFidoRoam;
      mpCtrl.isAccountHolder = !($rootScope.userInfo.profileType.subscriber);
      mpCtrl.isOwner = $rootScope.userInfo.profileType.owner;
      mpCtrl.isGroupId = $rootScope.userInfo.profileType.groupId;
      mpCtrl.dataByteLink = (mpCtrl.language === 'en') ? env.enDataByteLink : env.frDataByteLink;
      mpCtrl.fidoXtraLink = (mpCtrl.language === 'en') ? env.enFidoXtraLink : env.frFidoXtraLink;
      mpCtrl.dataByteImg = (mpCtrl.language === 'en') ? 'images/wireless-dashboard/5-hours-data.svg' : 'images/wireless-dashboard/5-hours-data-fr.svg';
      mpCtrl.fidoXtraImg = (mpCtrl.language === 'en') ? 'images/wireless-dashboard/fido-xtra.svg' : 'images/wireless-dashboard/fido-xtra-fr.svg';
      mpCtrl.learnMoreImg = (mpCtrl.language === 'en') ? 'images/wireless-dashboard/fido-roam.svg' : 'images/wireless-dashboard/fido-roam-fr.svg';
      mpCtrl.brtSwitchFidoRoamForNonPulse = permissionsService.permissionDetail.isFidoNonPulseRoam;

      mpCtrl.countryKeys = [
        'countries.1',
        'countries.2',
        'countries.3',
        'countries.4',
        'countries.5',
        'countries.6',
        'countries.7',
        'countries.8'
      ];

      fetchPricePlanDetails(cacheExpiredForPP);
      getAddonList();
      roamLikeHomeEligibility();
    }

    function getAddonList() {
      wirelessDashboardService.getAddon(mpCtrl.selectedBan, mpCtrl.selectedCtn)
        .then(function (response) {
          var addonListInfo = response.data;
          var masterAddonList;
          if (addonListInfo) {
            if (addonListInfo.addonDetailList) {
              masterAddonList = addonListInfo.addonDetailList;
              if (addonListInfo.addOnJsonList) {
                _.each(addonListInfo.addOnJsonList, function (addOnJsonInfo) {
                  _.each(addonListInfo.addonDetailList, function (addonDetailInfo) {
                    if (addOnJsonInfo.productId === addonDetailInfo.productCode) {
                      addonDetailInfo.contentInfo = addOnJsonInfo;
                    }
                  });
                });
                masterAddonList = addonListInfo.addonDetailList;
              }
            } else {
              if (addonListInfo.addOnJsonList) {
                masterAddonList = addonListInfo.addOnJsonList;
              }
            }
          }
          mpCtrl.addonList = masterAddonList;
        });
    }

    function roamLikeHomeEligibility() {
      wirelessDashboardService.getRlhNotification(mpCtrl.selectedBan, mpCtrl.selectedCtn)
        .then(function (response) {
            if (response.data.error || response.data.status === 'Failed') {
              console.log('RLH call failed with error 50000');
            } else {
              mpCtrl.evolutionEligible = response.data.evolutionEligibleFlag; //true;
              mpCtrl.evolutionOptInOut = response.data.evolutionOptInOutFlag; //true;
            }
          }
        ).catch(function () {
        console.log('session evolution eligible flag error' + mpCtrl.evolutionEligible);
      });
    }

    
    function fetchPricePlanDetails(refreshState) {
      wirelessDashboardService.getPlanDetails(mpCtrl.selectedBan, mpCtrl.selectedCtn, mpCtrl.billingProvince, refreshState)
        .then(function (response) {
          var data = response.data;
          if (data && data.errorCode) {
            mpCtrl.pricePlanInfoError = true;
          } else {
            if (data) {
              if (data.cachedResultInfo === null || data.cachedResultInfo === '' || (data.cachedResultInfo && data.cachedResultInfo.expired)) {
                if (!cacheExpiredForPP) {
                  cacheExpiredForPP = true;
                  fetchPricePlanDetails(cacheExpiredForPP);
                }
              }
              if (!_.isEmpty(data.featureGroupList)) {
                mpCtrl.featureGroupList = data.featureGroupList;
                //All of the below elements comes in []
                mpCtrl.overageRate = '';
                mpCtrl.addtionalPlanDetails = [];
                mpCtrl.otherPlanDetails = [];
                mpCtrl.pricePlanTalkFeatures =[];
                mpCtrl.pricePlanTextFeatures =[];

                var count = 0;
                _.each(mpCtrl.featureGroupList, function (featureGroupList) {
                  //Collecting the Text data from the label reference instead as the current feature-key collection is unknown
                  if(featureGroupList.featureGroup.label.en === "Text" ){
                    _.each(featureGroupList.featureGroup.featureList, function (featureList) {
                      mpCtrl.pricePlanTextFeatures.push( (mpCtrl.language === 'en') ? featureList.en : featureList.fr);
                    });
                  }
                  if (featureGroupList && featureGroupList.featureGroup && featureGroupList.featureGroup.featureList) {
                    _.each(featureGroupList.featureGroup.featureList, function (featureList) {

                      if (featureList.featureKey === 'DATAUSAGE') {
                        if (mpCtrl.language === 'en') {
                          var featureListEn = featureList.en.split(' ');
                          mpCtrl.pricePlanDataUsage = featureListEn[0] + '<span class="data_value">' + (featureListEn[1] || '') + '</span>';
                        } else {
                          var featureListFr = featureList.fr.split(' ');
                          mpCtrl.pricePlanDataUsage = featureListFr[0] + '<span class="data_value">' + (featureListFr[1] || '') + '</span>';
                        }
                      }
                      if (featureList.featureKey === 'OVERAGERATE') {
                        mpCtrl.overageRate = (mpCtrl.language === 'en') ? featureList.en : featureList.fr;
                      }
                      if (featureList.featureKey.toLowerCase() === 'talkminutes') {
                        mpCtrl.pricePlanTalkFeatures.push( (mpCtrl.language === 'en') ? featureList.en : featureList.fr);
                      }
                      if (featureList.featureKey === 'AdditionalPlanFeatures') {
                        mpCtrl.addtionalPlanDetails.push(mpCtrl.pricePlanAdditionalFeature = (mpCtrl.language === 'en') ? featureList.en : featureList.fr)
                      }
                      if (featureList.featureKey !== 'DATAUSAGE' && featureList.featureKey !== 'OVERAGERATE' && featureList.featureKey.toLowerCase() !== 'talkminutes' && featureList.featureKey.toLowerCase() !== 'unlimitedsms_cadtous&intl' && featureList.featureKey !== 'AdditionalPlanFeatures' ) {
                        mpCtrl.otherPlanDetails.push( (mpCtrl.language === 'en') ? featureList.en : featureList.fr);
                      }
                    });
                  } else {
                    mpCtrl.pricePlanInfoError = true;
                  }

                });
              } else {
                mpCtrl.pricePlanInfoError = true;
              }
              if (data.planTitle && data.planTitle.en && data.planTitle.fr) {
                mpCtrl.pricePlanTitle = (mpCtrl.language === 'en') ? data.planTitle.en : data.planTitle.fr;
              } else {
                if (data.wirelessPlanDetails) {
                  if (data.wirelessPlanDetails.planDetailsInfo) {
                    var planData;
                    planData = (mpCtrl.language === 'en') ? data.wirelessPlanDetails.planDetailsInfo.en : data.wirelessPlanDetails.planDetailsInfo.fr;
                    if (_.get(planData, 'planComparison.planTitle') !== '') {
                      mpCtrl.pricePlanTitle = planData.planComparison.planTitle;
                    } else {
                      mpCtrl.pricePlanTitle = (mpCtrl.language === 'en') ? data.wirelessPlanDetails.description : data.wirelessPlanDetails.descriptionFr;
                    }
                  } else {
                    mpCtrl.pricePlanTitle = (mpCtrl.language === 'en') ? data.wirelessPlanDetails.description : data.wirelessPlanDetails.descriptionFr;
                  }
                }
              }

              $timeout(function () {
                // sync the height of myPlan/myDevice headers
                wirelessDashboardService.myPlanBoxHeight($('.wireless_header_section2').outerHeight());
              });

              if (data.wirelessPlanDetails && data.wirelessPlanDetails.dbeligible) {
                mpCtrl.dataByteEligible = true;
              }
              if (data.planCost) {
                mpCtrl.pricePlan = data.planCost;
              } else {
                mpCtrl.pricePlan = data.wirelessPlanDetails ? data.wirelessPlanDetails.pricePlan : '';
              }
              mpCtrl.showGetCode = false;
            } else {
              mpCtrl.pricePlanInfoError = true;
            }
          }
        })
        .catch(function () {
          mpCtrl.pricePlanInfoError = true;
        });
    }

    mpCtrl.openEmbarrassingWindow = wirelessDashboardService.openEmbarrassingWindow;
    mpCtrl.changeCallerId = wirelessDashboardService.openChangeCallerId;
    mpCtrl.viewPromoCode = wirelessDashboardService.viewPromoCode;

    mpCtrl.filterNotIncludedFeature = function (groupFeature) {
      if (mpCtrl.language === 'en') {
        return (groupFeature && groupFeature.en !== 'Not Included');
      } else {
        return (groupFeature && groupFeature.fr !== 'Non compris');
      }
    };

    mpCtrl.displayToolTip = function (elm) {
      var countryPopOver = $('.country-pop-over')[0];
      var topPosition = countryPopOver.offsetTop;
      var leftPosition = countryPopOver.offsetLeft;
      var defaultLeftPosition = 30;
      var toolTipWidth = 265;
      var popOverPosition = defaultLeftPosition;
      var screenWidth = $window.innerWidth;
      if (leftPosition && leftPosition > 0) {
        var centerValue = toolTipWidth / 2;
        if ((leftPosition - centerValue) > defaultLeftPosition)
          popOverPosition = (leftPosition - centerValue);
      }
      if (screenWidth - popOverPosition < 265)
        popOverPosition = defaultLeftPosition;
      $('#country-popover-content').css(
        {
          'top': topPosition + 9 + 'px',
          'left': popOverPosition + 'px'
        });
      mpCtrl.close = !mpCtrl.close;
      countryPopOver = null;
    };

    mpCtrl.viewCountries = function () {
      uteModal.open({
        templateUrl: 'modules/my-account/wireless/rlh-cms-content.html',
        size: 'lg',
        controller: ['$scope', function ($scope) {
          $scope.isAsterisk = false;
        }]
      });
    };

    mpCtrl.planDetailspopup = function () {
      uteModal.open({
        templateUrl: 'modules/my-account/wireless/my-plan/plan-details-model.html',
        windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
        backdrop: 'static',
        windowClass: 'plan-details-modal_holder',
        size: 'sm',
        controller: ['$scope', '$modalInstance', '$translate', function ($scope, $modalInstance, $translate) {
          $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
          };
          $scope.pricePlanDataUsage = mpCtrl.pricePlanDataUsage;
          $scope.overageRate = mpCtrl.overageRate;
          $scope.pricePlanTalkFeatures = mpCtrl.pricePlanTalkFeatures;
          $scope.pricePlanTextFeatures = mpCtrl.pricePlanTextFeatures;
          $scope.addtionalPlanDetails = mpCtrl.addtionalPlanDetails;
          $scope.OtherFeatures = mpCtrl.otherPlanDetails;
        }]
      });
    };

    mpCtrl.viewCTNDetails = function () {
      mpCtrl.isOpenCTNDetals = !mpCtrl.isOpenCTNDetals;
    };
  }

})();
